import type React from 'react';
import { useEffect, useRef } from 'react';
import { Notify } from '../Notify';
import Button, { type Props } from './Button';

export interface UploadButtonProps extends Omit<Props, 'onClick'> {
  onUpload?: (files: File[]) => void;
  multiple?: boolean;
  accept?: string[];
  openOnMount?: boolean;
}

export default function UploadButton({
  onUpload,
  multiple = false,
  children,
  accept,
  openOnMount = false,
  ...props
}: UploadButtonProps) {
  const selector = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (openOnMount === true) {
      selector.current?.click();
    }
  }, [openOnMount]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles || !selectedFiles.length) {
      Notify.error({
        title: 'File Upload',
        message: 'No files selected.',
      });
      return;
    }

    const files: File[] = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const f = selectedFiles.item(i);
      if (f) {
        files.push(f);
      }
    }

    onUpload?.(files);
  };

  return (
    <>
      <Button
        onClick={() => {
          selector.current?.click();
        }}
        {...props}
      >
        {children}
      </Button>
      <input
        ref={selector}
        type="file"
        multiple={multiple}
        className="display-none hidden"
        onChange={onChange}
        accept={accept?.join(',')}
      />
    </>
  );
}
